import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {API} from "../config/api-config";

declare var alertify:any;
@Component({
  templateUrl:"./index.html"
})

export class SettingContent implements OnInit{

  constructor(
    private router:Router,
    private http:HttpService
  ){}

  private data:any=[];

  ngOnInit(): void {
    this.getData();
  }



  private getData(){
    this.http.getData(API.settingContent).then(res=>{
      this.data=res.data;
      for(let i=0;i<this.data.length;i++){
        if(typeof this.data[i].updatedTime=='object'){
          this.data[i].updatedTime='';
        }
      }

    });
  }

  private editSettingContent(code:string){
    this.router.navigate(['index/settingContent',code]);
  }

}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/settingContent/SettingContent.component.ts